import React from 'react';
import { Link } from 'react-router-dom';
import { checkPermission } from '../../Utils/permissionHelper';

const AddButton = ({
    to,
    children = 'Add',
    className = '',
    permission = null,
    disabled = false
}) => {
    const isDisabled = disabled || (permission && !checkPermission(permission));

    if (isDisabled) {
        return (
            <button
                className={`button button-them-gray admin-btn ${className}`}
                disabled={true}
                style={{ opacity: 0.6, cursor: 'not-allowed' }}
            >
                <i className="fas fa-plus" /> {children}
            </button>
        );
    }

    return (
        <Link to={to} className={`button button-them-gray admin-btn ${className}`}>
            <i className="fas fa-plus" /> {children}
        </Link>
    );
};

export default AddButton;


